import { render } from "./EditTagsCard.vue?vue&type=template&id=2066d325"
import script from "./EditTagsCard.vue?vue&type=script&lang=js"
export * from "./EditTagsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__